export default "__VITE_ASSET__BaoZ5LI7__"